"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var headers_1 = require("@wix/headers");
var utils_1 = require("./utils");
// we replaced `isomorphic-unfetch` because we want it to support web-workers
// see: https://github.com/developit/unfetch/pull/109
var unfetch = require('./isomorphic-unfetch');
// https://github.com/developit/unfetch/issues/46
var fetch = unfetch;
var serverlessBase = process.env.YOSHI_SERVERLESS_BASE;
var defaultBaseUrl = serverlessBase
    ? serverlessBase
    : "/_api/" + process.env.PACKAGE_NAME;
var default_1 = /** @class */ (function () {
    function default_1(_a) {
        var _b = (_a === void 0 ? {} : _a).baseUrl, baseUrl = _b === void 0 ? defaultBaseUrl : _b;
        this.baseUrl = baseUrl;
    }
    default_1.prototype.getWixHeaders = function () {
        var wixHeaders = headers_1.createHeaders();
        if (process.env.NODE_ENV === 'development') {
            delete wixHeaders['x-xsrf-token'];
        }
        return wixHeaders;
    };
    default_1.prototype.request = function (method, options) {
        var _this = this;
        return function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return __awaiter(_this, void 0, void 0, function () {
                var url, fileName, functionName, body, res, error, error, errorMessage, result;
                var _a;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            url = utils_1.joinUrls(this.baseUrl, '/_api_');
                            fileName = method.fileName, functionName = method.functionName;
                            body = { fileName: fileName, functionName: functionName, args: args };
                            return [4 /*yield*/, fetch(url, {
                                    credentials: 'same-origin',
                                    method: 'POST',
                                    headers: __assign(__assign({ 'Content-Type': 'application/json' }, this.getWixHeaders()), options === null || options === void 0 ? void 0 : options.headers),
                                    body: JSON.stringify(body),
                                })];
                        case 1:
                            res = _b.sent();
                            if (!!res.ok) return [3 /*break*/, 5];
                            if (!((_a = res.headers.get('content-type')) === null || _a === void 0 ? void 0 : _a.includes('application/json'))) return [3 /*break*/, 3];
                            return [4 /*yield*/, res.json()];
                        case 2:
                            error = _b.sent();
                            if (process.env.NODE_ENV !== 'production') {
                                if (process.env.browser) {
                                    utils_1.showToast(error, method, args, this.baseUrl);
                                }
                                console.error(error);
                            }
                            throw new Error(JSON.stringify(error));
                        case 3: return [4 /*yield*/, res.text()];
                        case 4:
                            error = _b.sent();
                            errorMessage = "\n              Yoshi Server: the server returned a non JSON response.\n              This is probable due to an error in one of the middlewares before Yoshi Server.\n              " + error + "\n            ";
                            if (process.env.NODE_ENV !== 'production') {
                                console.error(error);
                            }
                            throw new Error(errorMessage);
                        case 5: return [4 /*yield*/, res.json()];
                        case 6:
                            result = _b.sent();
                            return [2 /*return*/, result.payload];
                    }
                });
            });
        };
    };
    return default_1;
}());
exports.default = default_1;
//# sourceMappingURL=index.js.map